import DefaultStoryThreadLayout from "@routes/StoryThread/layouts/DefaultStoryThreadLayout.tsx";

export const StoryThreadLayout = (urlPath: string) => {
  switch (urlPath) {
    default:
      return DefaultStoryThreadLayout;
  }
};
